import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["questionList", "questionTypeSelect"]

  connect() {
    this.initSortable()
  }

  disconnect() {
    this.sortable?.destroy()
  }

  // -- Sortable --

  initSortable() {
    if (!this.hasQuestionListTarget) return

    this.sortable = Sortable.create(this.questionListTarget, {
      handle: ".drag-arrow",
      axis: "y",
      animation: 150
    })
  }

  // -- Add question --

  addQuestion(event) {
    event.preventDefault()

    const questionType = this.questionTypeSelectTarget.value
    const template = document.getElementById(`new_${questionType}_question`)
    if (!template) return

    const node = this.stampTemplate(template)
    this.questionListTarget.appendChild(node)
  }

  // -- Remove parent --

  removeParent(event) {
    event.preventDefault()

    const selector = event.currentTarget.dataset.formBuilderParentSelector
    const parent = event.currentTarget.closest(selector)
    if (!parent) return

    parent.style.transition = "opacity 300ms"
    parent.style.opacity = "0"
    setTimeout(() => parent.remove(), 300)
  }

  // -- Append template --

  appendTemplate(event) {
    event.preventDefault()

    const templateSelector = event.currentTarget.dataset.formBuilderTemplateSelector
    const targetSelector = event.currentTarget.dataset.formBuilderTargetSelector
    const template = document.querySelector(templateSelector)
    const target = document.querySelector(targetSelector)
    if (!template || !target) return

    const node = this.stampTemplate(template)
    target.appendChild(node)
  }

  // -- Private --

  stampTemplate(template) {
    const node = document.importNode(template.content, true)
    const stampType = template.dataset.stamp

    const placeholder = stampType === "question" ? /__QUESTION_INDEX__/g : /__CHOICE_INDEX__/g
    const replacement = Date.now().toString()

    Array.from(node.children).forEach((child) => {
      child.innerHTML = child.innerHTML.replace(placeholder, replacement)
    })

    return node
  }
}
